import {
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaRegDotCircle } from "react-icons/fa";
import { IoChevronBackOutline } from "react-icons/io5";
// import { LuCalendar, LuClock4 } from "react-icons/lu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getServices } from "../../apiServices/apiServices";
import LoadingGif from "../../assets/loading_anim.gif";
import "react-datepicker/dist/react-datepicker.css";
import ManifoldReportTable from "../../components/common/ManifoldReportTable";
import { MdOutlineMoreVert } from "react-icons/md";
// import EmptyingReport from "../reports/EmptyingReport";

function ControllerDetails() {
  const [controllerDetails, setControllerDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [manifoldReportData, setManifoldReport] = useState([]);
  const location = useLocation().state;
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-super-admin-token");

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchControllerDetails();
  }, []);

  const fetchControllerDetails = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/data?hardware_id=${location.hardware_id}`
      );
      setLoading(false);

      if (res.responseCode === 200) {
        // fetchBurnerRunTimeReport(res.responseData[0]?.branch);
        fetchManifoldReportData(true, res.responseData[0]?.branch);
        setControllerDetails(res.responseData[0]);
      } else {
        setControllerDetails({});
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };
  const fetchManifoldReportData = async (load_bool, branch_id) => {
    setLoading(load_bool);
    try {
      const res = await getServices(
        `/api/device/manifold/runtime?branch_id=${branch_id}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setManifoldReport(res.responseData?.data);
      } else {
        setManifoldReport([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
          <div className="flex gap-3 sm:gap-6">
            <Link
              to={-1}
              className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
            >
              <IoChevronBackOutline />
              <p className="text-base sm:text-xl">Controller Details</p>
            </Link>
            {!loading && (
              <div
                className={`flex items-center gap-2 text-[15px] px-7 py-2 rounded-full ${
                  controllerDetails.running_status === 1
                    ? "text-yellow-600 bg-yellow-50"
                    : controllerDetails.running_status === 2
                    ? "text-green-600 bg-green-50"
                    : controllerDetails.running_status === 3
                    ? "text-red-600 bg-red-100"
                    : ""
                }`}
              >
                <FaRegDotCircle />
                <p>
                  {controllerDetails.running_status === 1
                    ? "Listed"
                    : controllerDetails.running_status === 2
                    ? "Activated"
                    : controllerDetails.running_status === 3
                    ? "Deactivated"
                    : "-"}
                </p>
              </div>
            )}
          </div>
          {!loading && (
            <div className="text-[#BDBDBD] text-right flex justify-end md:block w-full md:w-[unset]">
              Activated on: {controllerDetails.actvtd_on ?? "-"}
            </div>
          )}
        </div>

        {!loading ? (
          <>
            <div className="flex md:justify-between md:items-center flex-col md:flex-row gap-1 sm:gap-2 mt-4 md:mt-8">
              <div>
                <p className="text-[#BDBDBD] text-sm">Hardware ID</p>
                <p className="text-black font-bold text-4xl">
                  #{controllerDetails.hardware_id ?? "-"}
                </p>
              </div>
              <div className="md:text-right">
                <p className="text-[#BDBDBD] flex items-center gap-2">
                  Company Name:{" "}
                  <span className="font-bold text-black text-xl capitalize">
                    {location?.controller_data?.company_name}
                  </span>
                </p>
                <p className="text-[#BDBDBD] flex items-center gap-2">
                  Branch:{" "}
                  <span className="font-bold text-black text-xl capitalize">
                    {location?.controller_data?.branch}
                  </span>
                </p>
              </div>
            </div>

            <div className="mt-6">
              <div className="grid lg:grid-cols-2 gap-5">
                <div className="flex flex-col gap-5">
                  <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 rounded-3xl h-fit flex flex-col gap-5">
                    <p className="text-[13px] text-[#BDBDBD] font-medium">
                      Contact Info
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Contact Person Name:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Phone no.:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person_no ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Email Address:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person_email ?? "-"}
                      </span>
                    </p>
                  </div>

                  <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 rounded-3xl h-fit flex flex-col gap-5">
                    <p className="text-[13px] text-[#BDBDBD] font-medium">
                      Address
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      District:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.district ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      State:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.state ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Pin code:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.pincode ?? "-"}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 lg:px-20 rounded-3xl h-fit">
                  <p className="font-medium text-[#BDBDBD] text-[13px]">
                    For Normal Communication
                  </p>
                  <div className="mt-4 grid grid-cols-2">
                    <div className="flex flex-col gap-3">
                      {controllerDetails?.communication?.normal_email
                        ?.filter((item) => item !== "")
                        ?.map((email, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Email {i + 1}:{" "}
                            <span className="text-black">{email}</span>
                          </p>
                        ))}
                    </div>

                    <div className="flex flex-col gap-3 items-end">
                      {controllerDetails?.communication?.normal_phone
                        ?.filter((item) => item !== "")
                        ?.map((phone, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Phone {i + 1}:{" "}
                            <span className="text-black">{phone}</span>
                          </p>
                        ))}
                    </div>
                  </div>

                  <hr className="my-8 w-[90%] mx-auto border-[#BDBDBD] border-t-2" />

                  <p className="font-medium text-[#BDBDBD] text-[13px]">
                    For Critical Communication
                  </p>
                  <div className="mt-6 grid grid-cols-2">
                    <div className="flex flex-col gap-3">
                      {controllerDetails?.communication?.critical_email
                        ?.filter((item) => item !== "")
                        ?.map((email, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Email {i + 1}:{" "}
                            <span className="text-black">{email}</span>
                          </p>
                        ))}
                    </div>

                    <div className="flex flex-col gap-3 items-end">
                      {controllerDetails?.communication?.critical_phone
                        ?.filter((item) => item !== "")
                        ?.map((phone, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Phone {i + 1}:{" "}
                            <span className="text-black">{phone}</span>
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 md:mt-8">
              <div className="flex justify-end mb-4 gap-3">
                {/* <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/burner_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Burner Report
                </Button>
                <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Cylinder Report
                </Button> */}
                {controllerDetails?.reportInfo?.[0]?.gld_report !== 0 && (
                  <Button
                    onClick={() => {
                      navigate("/controller_details/gld_logs", {
                        state: { controllerDetails: controllerDetails },
                      });
                    }}
                    className="font-poppins font-medium tracking-wider bg-[#03438D]"
                  >
                    GLD Logs
                  </Button>
                )}

                <Menu placement="left-start">
                  <MenuHandler title="Click to open reports">
                    <Button className="p-2 rounded-full bg-[#03438D] outline-none">
                      <MdOutlineMoreVert className="text-2xl" />
                    </Button>
                  </MenuHandler>
                  <MenuList>
                    {controllerDetails?.reportInfo?.[0]?.br_report === 1 && (
                      <MenuItem
                        onClick={() => {
                          window.open(
                            `/controller_details/burner_report/${controllerDetails.branch}`,
                            "_blank"
                          );
                        }}
                        className="font-poppins"
                      >
                        Burner Report
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Cylinder Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/emptying_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Emptying Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offline_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Offline Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offtime_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Off-time Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/graph_view/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Graph View
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>

              {/* manifold report */}
              {manifoldReportData.length > 0 ? (
                // {controllerDetails ? (
                <>
                  <ManifoldReportTable
                    manifoldReportData={manifoldReportData}
                    controllerDetails={controllerDetails}
                  />
                  {/* <EmptyingReport branch_id={controllerDetails.branch} /> */}
                </>
              ) : (
                <div className="text-center h-[50vh] flex flex-col justify-center items-center text-black">
                  <p className="font-semibold text-xl sm:text-3xl">
                    Oops! No Data Found...
                  </p>
                  <p className="text-sm mt-2 ">
                    Looks like we couldn't find any branch that match your
                    search right now.
                  </p>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default ControllerDetails;
